/* global JSX */
// ListColumn
// ***********************************************************************************************************************
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Box, Checkbox, Grid } from "@mui/material";
import * as React from "react";
import { ClipTypography } from "../../Typography/ClipTypography";

export interface IListColumnData {
    style?: any;
    styleClass?: string; //Used in task dynamic forms: list view and excel report
    content: string | JSX.Element;
    size?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    tooltip?: string;
    padding?: string | number;
    hidden?: boolean;
}

// ListHeaderColumn
export interface IListHeaderColumnData extends IListColumnData {
    column?: string;
    defaultChecked?: boolean;
}

export interface IListHeaderColumnProp extends IListHeaderColumnData {
    sortColumn?: string;
    sortOrderIsAsc?: boolean;
    defaultChecked?: boolean;
    onClick?: (column: string) => void;
    onCheckboxChange?: (column: string, checked: boolean) => void;
}

export class ListHeaderColumn extends React.Component<IListHeaderColumnProp, {}> {
    static defaultProps = {
        padding: "9px 0"
    };

    handleClick = (e) => {
        const props = this.props;
        if (!props.column) return;
        e.preventDefault();
        e.stopPropagation();
        props.onClick(props.column);
    };

    handleCheckboxChange = (e) => {
        const props = this.props;
        e.stopPropagation();
        props.onCheckboxChange(props.column, e.target.checked);
    };

    render() {
        const props = this.props;
        const spanClass = props.sortColumn ? ("sort " + (props.column === props.sortColumn ? (props.sortOrderIsAsc ? "asc" : "desc") : "")) : "";
        return (
            <Grid
                item
                className={props.styleClass ?? ""}
                sm={props.size}
                onClick={props.onClick ? this.handleClick : null}
                title={props.tooltip ?? (typeof props.content === "string" ? props.content : "")}
                sx={{ cursor: props.column ? "pointer" : "default", padding: props.padding, overflow: "hidden", alignSelf: "center" }}
                style={props.style}
            >
                <Box sx={{ padding: "0 .5rem" }} display="flex" alignItems="center">
                    {!!props.onCheckboxChange &&
                        <Checkbox onClick={this.handleCheckboxChange} defaultChecked={props.defaultChecked} value="" />
                    }
                    {(typeof props.content === "string"
                        ? <ClipTypography>{props.content}</ClipTypography>
                        : props.content)
                    }
                    {props.sortColumn === props.column && props.sortOrderIsAsc && (
                        <ArrowDownwardIcon sx={{ color: "#667085", marginLeft: "8px" }} fontSize="small" />
                    )}
                    {props.sortColumn === props.column && !props.sortOrderIsAsc && (
                        <ArrowUpwardIcon sx={{ color: "#667085", marginLeft: "8px" }} fontSize="small" />
                    )}
                    <span className={spanClass}></span>
                </Box>
            </Grid>
        );
    }
}

// ListValueColumn
export interface IListValueColumnData extends IListColumnData {
    disabled?: boolean;
    errors?: string[];
}

export interface IListValueColumnProp extends IListValueColumnData {
    id?: string;
    checked?: boolean;
    valueClasses?: string;
    onValueClick?: (id: string) => void;
    onCheckboxChange?: (id: string, checked: boolean) => void;
}

export class ListValueColumn extends React.Component<IListValueColumnProp, {}> {
    handleCheckboxChange = (e) => {
        const props = this.props;
        e.stopPropagation();
        if (!props.id) return;
        props.onCheckboxChange(props.id, e.target.checked);
    };

    handleValueClick = (e) => {
        const props = this.props;
        if (!props.onValueClick) return;
        //e.stopPropagation();
        if (!props.id) return;
        props.onValueClick(props.id);
    };

    //To prevent react warning message
    handleChange = (e) => {
    };

    render() {
        const props = this.props;
        const hasErrors = props.errors && props.errors.length > 0;
        let tooltip = props.tooltip ?? (typeof props.content === "string" ? props.content : "");
        if (hasErrors) {
            tooltip = props.errors.join(",");
        }
        return (
            <Grid item className={props.styleClass ?? ""} sm={props.size} title={tooltip} sx={{ overflow: "hidden", alignSelf: "center", height: "100%", alignItems: "center", display: "flex", userSelect: "none" }} style={props.style} bgcolor={hasErrors ? "error.main" : null}>
                <Box sx={{ padding: "0 .5rem", width: "100%" }} display="flex" alignSelf="center" alignItems="center" className="colValueContainer">
                    {!!props.onCheckboxChange &&
                        <Checkbox checked={props.checked} disabled={props.disabled} onChange={this.handleChange} onClick={this.handleCheckboxChange} value={props.id} />
                    }
                    {(typeof props.content === "string"
                        ? <ClipTypography onClick={this.handleValueClick} title={tooltip}>{props.content}</ClipTypography>
                        : props.content)
                    }
                </Box>
            </Grid>
        );
    }
}